import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { readAppConfig } from "./config/ReadAppConfig";
import { initFaro } from "./observability/InitFaro";
import { ErrorBoundary } from "./observability/ErrorBoundary";

const appConfig = readAppConfig();
if (appConfig.faroUrl !== null) {
  initFaro({
    url: appConfig.faroUrl,
    appName: "link-factory-admin",
    appVersion: appConfig.appVersion,
    environment: appConfig.environment,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
